import { useState, useEffect } from 'react';

const SIZES = {
  small: 'h-4', // 16px
  medium: 'h-6', // 24px
  large: 'h-8', // 32px
  extraLarge: 'h-10', // 40px
};

interface IconProps {
  name: string;
  size?: keyof typeof SIZES;
  alt?: string;
}

export const PngIcon = ({ size = 'medium', name, alt = name }: IconProps) => {
  const [imageUrl, setImageUrl] = useState<string>('');

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await import(`../assets/pngs/${name}.png`);
        setImageUrl(response.default);
      } catch (error) {
        console.error(`${error}: Icon with name: ${name} not found!`);
      }
    };

    fetchImage();

    return () => setImageUrl('');
  }, [name]);

  return (
    <img
      className={`${SIZES[size]} w-auto`} // dynamic Tailwind height, auto width
      src={imageUrl}
      alt={alt}
    />
  );
};
